<template>
	<div>
		<HomeButton></HomeButton>
		<section class="bg-account-pages height-100vh">
			<div class="display-table">
				<div class="display-table-cell">
					<div class="container">
						<b-row class="justify-content-center">
							<b-col cols="12" sm="10" md="8" lg="6">
								<b-card style="">
									<b-row style="margin-top: -14px">
										<b-button-group class="w-100 h-100">
											<!-- :variant="selecionado === 1 ? 'primary' : 'outline - primary'" -->
											<b-button
												@click="selecionado = 1"
												:style="
													selecionado === 1
														? 'background-color: rgba(62, 37, 82, 1); color: white'
														: 'background-color: rgba(255, 255, 255, 1); color: black;  border: 0px'
												"
											>
												<i class="fa-regular fa-user-unlock"></i>
												Usuário e Senha
											</b-button>
											<!-- :variant="selecionado === 2 ? 'primary' : 'outline - primary'" -->
											<b-button
												:style="
													selecionado === 2
														? 'background-color: rgba(62, 37, 82, 1); color: white'
														: 'background-color: rgba(255, 255, 255, 1); color: black; border: 0px'
												"
												@click="selecionado = 2"
											>
												<i class="fa-sharp fa-regular fa-key"></i> Chave de acesso
											</b-button>
										</b-button-group>
									</b-row>
									<b-row>
										<LoginCommun v-if="selecionado === 1" />
										<LoginSMS v-if="selecionado === 2" />
									</b-row>
								</b-card>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import LoginCommun from './LoginCommun.vue'
	import HomeButton from './Elements/HomeButton'
	import LoginSMS from './LoginSMS.vue'
	export default {
		components: {
			LoginCommun,
			LoginSMS,
			HomeButton
		},
		data() {
			return {
				selecionado: 1
			}
		},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700|Rubik:300,400,500');
	@import './assets/css/pe-icon-7-stroke.css';
	@import './assets/css/materialdesignicons.min.css';
	@import './assets/css/style.css';
	@import './assets/css/colors/red.css';
</style>
